import React, { useMemo } from 'react';
import useResizeWindows from '../../../utils/hooks/useResizeWindow';
import { Modal } from 'antd';

const FormFinishModal = ({ applicationState, setApplicationState }) => {
  const width = useResizeWindows();

  // стоит выделить компонент или блок кода, но мне лень // а мне нет
  const modalBody = useMemo(() => {
    let ret
    if (applicationState.pending) {
      ret = <p>Ожидаем сервер...</p>
    } else if (applicationState.error || applicationState.result?.status === 'error') {
      ret = <div className='bad'><p>{`${applicationState.error}`}</p></div>
    } else if (applicationState.result?.status === 'success') {
      ret = <div className='good'>
        <div className='header'></div>
        <div className='body'><span style={{
          whiteSpace: width > 1024 ? 'nowrap' : 'initial'
        }}>Ваша заявка принята.</span><br/>Мы с&nbsp;Вами свяжемся в&nbsp;ближайшее время!</div>
      </div>
    }
    return ret
  }, [applicationState, width]);
  return (
    <Modal
      open={applicationState.showingModal}
      title={applicationState.result ? "Присоединяйтесь к команде" : null}
      onOk={() => {
        setApplicationState({showingModal: false})
      }}
      onCancel={() => {
        setApplicationState({showingModal: false})
      }}
      footer={null}
      style={{
        maxWidth: applicationState.result?.status === 'success' ? 'min-content' : 'max-content',
      }}
    >
    <div className='request-modal'>
      {modalBody}
    </div>
    </Modal>
  )
}

export default FormFinishModal;
